export const composeValidators = (...validators: Function[]): (value: string) => string | undefined => {
  const componentValidator = (value: string): string | undefined => validators.reduce(
    (error, validator) => error || validator(value),
    undefined,
  );
  return componentValidator;
};
